import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  pub: {
    page: {
      index: 'No.'
    },
    btn: {
      search: 'Search'
    },
    exportExcel: {
      exportExcel: 'Export'
    }
  },
  taskprogress: {
    page: {
      username: 'Full Name',
      enterPhone: 'Phone for Sign-up',
      teamName: 'Team Name',
      teamNo: 'Team Number',
      schoolName: 'School Name',
      gradeCode: 'Grade',
      groupName: 'Academic Category',
      currentTaskTitle: 'Current Task',
      taskDoneCount: 'Task Progress',
      progressTask: 'Rank of Task Progress'
    },
    placeholder: {
      username: 'Full Name'
    }
  },
  regrecord: {
    page: {
      phone: 'Phone for Log-in',
      enterPhone: 'Phone for Sign-up',
      email: 'Email',
      username: 'Full Name',
      schoolName: 'School Name',
      areaName: 'Province',
      contestName: 'Competition Season',
      gradeCode: 'Grade',
      groupName: 'Academic Category',
      enterTime: 'Sign-up Time',
      orderTitle: 'Order Title',
      productNames: 'Payment Item',
      orderId: 'Order ID',
      orderStatus: 'Order Status',
      payTime: 'Pay Time',
      payStatus: {
        lable: 'All',
        lable1: 'Unpaid',
        lable2: 'Canceled',
        lable3: 'Paid',
        lable4: 'Refund',
        lable5: 'Refunded'
      }
    },
    placeholder: {
      phone: 'Phone Number',
      username: 'Full Name',
      orderStatus: 'Payment Status',
      taskRelationId: 'Name of the Fee',
      AdmissionTicket: 'Please select the admission',
      AcademicReport: 'Please select the Academic report'
    }
  },
  jobrecords: {
    placeholder: {
      username: 'Fill in the username',
      selectjob: 'Please select an assignment'
    },
    tab: {
      index: 'No.',
      studentName: 'Name',
      grade: 'Grade',
      languageGroup: 'Group',
      teamName: 'Team Name',
      workGroupType: 'Homework type',
      modifyTime: 'Issued Time',
      submitTime: 'Submission Time',
      reviewStatusName: 'Review Status',
      isPassName: 'Passed or Not',
      score: 'Score',
      operate: 'Operate',
      view: 'View',
      task: 'Task',
      school: 'School'
    },
    details: {
      title: 'View Homework Details',
      workDetails: 'Homework Information',
      studentDetails: 'Student Information',
      reviewDetails: 'Review Information',
      Last: 'Last',
      Next: 'Next',
      Close: ''
    }
  },
  notice: {
    page: {
      name: 'Title',
      content: 'content',
      files: 'File',
      tag: 'Type',
      contentType: 'Content Type'
    },
    placeholder: {
      name: 'Title',
      tag: 'Type'
    }
  },
  login: {
    username: 'Account：',
    password: 'Password：',
    imgcode: 'Code：',
    smscode: 'SMS Code：',
    title: 'Coaching System',
    btnTxt: 'Login',
    placeholder: {
      username: 'Fill in the username',
      password: 'Fill in the password',
      imgcode: 'Fill in the image code',
      smscode: 'Fill in the SMS code'
    },
    alert: {
      username: 'Fill in the username',
      password: 'Fill in the password',
      imgcode: 'Fill in the image code',
      smscode: 'Fill in the SMS code'
    }
  },
  index: {
    alert: {
      userinfo: 'Dear Coach, welcome to the USAD Competition Management Portal. Please fill in the personal information before you take other actions',  // 提醒教练完成信息填写
      logout: 'Log out' // 退出登录提醒
    },
    btn: {
      logout: 'Log out' // 退出登录按钮文字
    },
    footinfo: '粤ICP备16089044号-2 ©Copyright SKT Education 版权所有 Powered by SKT Education' // 版权声明
  },
  menu: {
    user: 'Profile',
    coachdetails: 'Personal Information',
    UScoachdetails: 'US Personal Information',
    activity: 'Event',
    teaminfo: 'Build a team',
    coachfiles: 'Announcements',
    event: 'Data',
    regrecord: 'Student Information',
    progresstask: 'Task Progress',
    gradeQuery: 'gradeQuery',
    localGradeQuery: 'localGradeQuery',
    home: 'Home',
    eventManagement: 'Event Management',
    coachCenter: 'Coach Center',
    account: 'Account',
    switchStudent: 'Switch Student',
    loginOut: 'Log Out'
  },
  coach: {
    page: {
      title: 'Personal Information',
      title2: 'Please fill in your personal information.',
      title3: 'School'
    },
    form: {
      name: 'Full Name*（Name on Passport）',
      pinyinFirstName: 'Last Name*',
      pinyinLastName: 'First Name*',
      phone: 'Phone Number*',
      email: 'Email*（Make sure the email address is available for receiving the essential information）',
      courseSystem: 'Course System',
      coachType: 'Coach Status*',
      contacts: 'Additional Contacts（Additional email addresses for receiving essential information）',
      contactName: 'Contact Name',
      contactEmail: 'Email',
      placeholder: {
        name: 'Fill in the full name，e.g.: Emma Watson',
        pinyinFirstName: 'Fill in the last name，e.g.: Watson',
        pinyinLastName: 'Fill in the first name，e.g.: Emma',
        phone: 'Fill in the phone number',
        email: 'Fill in the email address ',
        coachType: 'Choose the coach status',
        courseSystem: 'Please select course system',
        contactName: 'Fill in the full name',
        contactEmail: 'Fill in the email address'
      },
      coachTypes: {
        label1: 'Teacher',
        label2: 'Parent',
        label3: 'Student'
      },
      courseSystems: {
        label1: 'AP',
        label2: 'IB',
        label3: 'A-level',
        label4: 'Canadian Curriculum system',
        label5: 'College Entrance Examination Curriculum System',
        label6: 'Others'
      }
    },
    btn: {
      save: 'SAVE',
      cancel: 'CANCEL'
    },
    alert: {
      coachId: 'Error.Please log in again.',
      success: 'Information saved',
      courseSystem: 'Please select course system'
    },
    menu: {
      courseL: 'Course',
      certification: 'Certification'
    }
  },
  uscoach: {
    page: {
      title: 'Personal Information',
      title3: 'Please fill in your personal information.'
    },
    form: {
      upload: 'Full Name*（Name on Passport）',
      firstName: 'Last Name*',
      lastName: 'First Name*',
      passportId: 'Passport Id*',
      email: 'Email*（Make sure the email address is available for receiving the essential information）',
      birthday: 'Birthday*',
      contacts: 'Additional Contacts（Additional email addresses for receiving essential information）',
      contactName: 'Contact Name',
      allergenCollection: 'Email',
      quantityOfPeople: 'QuantityOfPeople',
      serviceProject: 'ServiceProject',
      placeholder: {
        firstName: 'Fill in the last name，e.g.: Watson',
        lastName: 'Fill in the first name，e.g.: Emma',
        passportId: 'Fill in the Passport Id',
        email: 'Fill in the email address ',
        birthday: 'Fill in the Birthday',
        contactName: 'Fill in the full name',
        cateringNeedsElse: 'Fill in the catering needs else',
        allergenCollection: 'Fill in the email address',
        quantityOfPeople: 'Fill in the quantity of people',
        serviceProject: 'Fill in service project'
      },
      cateringNeeds: {
        label1: 'Vegetarian Diet',
        label2: 'General',
        label3: 'Moslem Food'
      },
      serviceProjects: {
        label1: '基础服务（后勤服务、报名服务、参与费）',
        label2: '附加服务（签证、EVUS更新）'
      }
    },
    btn: {
      save: 'SAVE',
      update: 'UPDATE',
      cancel: 'CANCEL'
    },
    alert: {
      coachId: 'Error.Please log in again.',
      success: 'Information saved'
    }
  },
  team: {
    page: {
      title: 'Team Management',
      tips: 'Please read the "team instructions" and complete the team formation information submission',
      details: 'Team Information',
      filedes: 'Upload the Student Scores Certification*',
      schoolNum: 'Fill in the student enrollment*',
      explain: {
        line1: 'Please provide the total number of students of your school in the current school year. The information is only used for classifying schools into different school divisions. If there are participants of Grade 9 students, the total number should cover Grade 9 to Grade 12 within your school. Please fill in the actual number, otherwise, it will affect your eligibility for participating USAD China.',
        line2: '* If students are all from the main campus, fill in the student enrollment of the main campus;',
        line3: '* If students are all from the international department, fill in the student enrollment of the international department;',
        line4: '* If the participants involve both main campus and international department students, please fill in the combined number of main campus and international department.',
        line5: '* The student enrollment should involve all grades of the school.'
      },
      usad: {
        teamdes1: '* Information will be unavailable to be modified after ',
        teamdes2: '* For the individual pentathletes, a table is for one pentathlete. Choose the pentathlete as team leader.',
        teamdes3: '* For the team pentathletes, a table is for a whole team. Assign a pentathlete as team leader. ',
        teamdes4: '.',
        teamdes5: '* Team Information：'
      },
      usap: {
        teamdes1: '* Information will be unavailable to be modified after ',
        teamdes2: '* For the individual pentathletes, a table is for one pentathlete. Choose the pentathlete as team leader.',
        teamdes3: '* For the team pentathletes, a table is for a whole team. Assign a pentathlete as team leader. ',
        teamdes4: '.'
      },
      teamlable: 'Student Information*'
    },
    placeholder: {
      schoolNum: 'Please fill in the school enrollment.'
    },
    alert: {
      delfile: 'Please delete the previous file before upload a new one.',
      delfilecf: 'Delete Successfully.',
      filesuccess: 'Upload Successfully.',
      uploadfile: 'Please upload the Student Scores Certification first.',
      save: 'Please save or submit the information.'
    },
    btn: {
      upload: 'Click to upload',
      download: 'Instructions of Student Scores.xlsx',
      scoredown: 'Student Scores Certification Template.xlsx',
      add: 'Add a team or an individual',
      agree: 'Agree'
    }
  },
  teamdetail: {
    page: {
      groupName: 'Academic Category',
      enterName: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      gradeCode: 'Grade',
      gpaScore: 'GPA',
      rateScore: 'Rankings (%)',
      groupTest: 'Group test',
      totalScore: 'Total Scores',
      mathScore: 'Mathematics',
      englishScore: 'English language',
      scienceScore: 'Science',
      groupPersonNum: 'The Number of Participants',
      leaderId: 'Team Leader',
      auditReason: 'Notes',
      cancelTitle: 'The operation will be irrevocable, are you sure to continue? ',
      cancelTip: 'Notes',
      cancelConfirm: 'Confirm',
      cancelCancel: 'CANCEL',
      unfold: 'Unfold',
      fold: 'Fold',
      auditStatus: {
        label1: 'Materials being reviewed...',
        label2: 'Approved',
        label3: 'Not Approved'
      },
      groupTypes: {
        label32: 'Honor',
        label33: 'Scholastic',
        label34: 'Varsity',
        label35: 'Honor',
        label36: 'Scholastic',
        label37: 'Varsity'
      }
    },
    placeholder: {
      enterName: 'Choose a student'
    },
    alert: {
      timeLimit: 'The deadline for organizing the team has passed',
      gpaScore: 'Fill in the GPA',
      groupTestNum: 'Please fill in the total number of participants in the group test first',
      gpaScore0_5000: 'GPA range of Honor is 0.000~4.000.',
      gpaScore0_3749: 'GPA range of Scholastic is 0.000~3.799.',
      gpaScore0_2999: 'GPA range of Varsity is 0.000~3.199.',
      rateScore: 'Fill in the rankings in percentage',
      rateScore00_100: 'Rankings range of Honor is 0.00%~100.00%.',
      rateScore20_100: 'Rankings range of Scholastic is 20.00%~100.00%.',
      rateScore50_100: 'Rankings range of Varsity is 50.00%~100.00%.',
      users: 'Please choose the team members.',
      userRange: '6-9 students for a team. 1 student for an individual decathlete.',
      userLimit: 'There should be 2-3 students in each academic category.',
      userLimit2: 'The number of seed groups should be greater than 1.',
      leaderId: 'Assign a team leader and submit again.',
      recurrent: 'Do not choose a student who is already in a team.',
      cancelTeam: 'The option is not available.',
      cancelSuc: 'Team dissolved successfully!',
      success0: 'Information saved',
      success1: 'Information submit',
      success2: 'Information submit'
    },
    btn: {
      gpa: 'GPA',
      rate: 'Rankings (%)',
      group: 'Group test',
      cancel: 'Dissolve the team',
      submit: 'Submit',
      resubmit: 'Resubmit',
      save: 'Save'
    }
  },
  seed: {
    seed: 'USAD Seed',
    classic: 'USAD',
    rules: '* Rules of forming a team: 3 to 4 students. One student cannot form a team.'
  },
  restructure: {
    welcome: 'Welcome',
    switch: 'switch',
    activity: 'Activity',
    select: 'Select',
    selectPlaceholder: 'Please select an activity season',
    comingSoon: 'Coming soon～',
    onlineTest: 'Online Test',
    scoreReport: 'AcademicReport',
    noData: 'No Data',
    noData2: 'Please select an assignment first',
    introduction: 'Introduction：',
    to: 'to',
    catalog: 'Catalog',
    finished: 'finished',
    unfinished: 'unfinished',
    open: 'open',
    close: 'close',
    certification: 'Certification',
    get: 'get',
    download: 'Download',
    share: 'Share',
    remake: 'Remake',
    remakeCertificate: 'Remake Certificate',
    shareQr: 'Open mobile wechat, scan QR code and share certificate to wechat / circle of friends ~',
    school: 'School',
    name: 'Name',
    cancel: 'Cancel',
    confirm: 'Confirm',
    tips: 'Each certificate can be re-created only once. Please make sure your personal information is correct',
    headPortrait: 'Head Portrait',
    change: 'Change',
    tips2: 'The recommended size is 250 * 250, the format is JPG and PNG, and the picture is less than 3M',
    personalInformation: 'Personal Information',
    moreContacts: 'More Contacts',
    accountSettings: 'Account Settings',
    account: 'Account',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    changePassword: 'Change Password',
    tips3: 'Information of other participants',
    previous: 'Previous',
    next: 'Next',
    submit: 'Submit',
    answerSheet: 'Answer Sheet',
    answered: 'Answered',
    unanswered: 'Unanswered',
    single: 'Single',
    multiple: 'Multiple',
    completion: 'Completion',
    score: 'Score',
    numberOftopics: 'Topics',
    incorrectly: 'Incorrectly',
    time: 'Time ',
    dao: ' ',
    achievementReport: 'Report',
    answerAnalysis: 'Analysis',
    analysis: 'Analysis',
    rightKey: 'Right Key',
    yourAnswer: 'Your Answer',
    wrong: 'Wrong',
    correct: 'Correct',
    whole: 'Whole',
    firstName: 'First Name',
    lastName: 'Last Name',
    title: {
      scoreQuery: 'Academic Report',
      registrationRecord: 'Registration Record',
      announcement: 'Announcement',
      course: 'Course',
      AdmissionTicket: 'Admission Ticket',
      JobRecords: 'Homework Records'
    }
  },
  ...enLocale
}
export default en



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/en.js